const data = window.location.origin + window.location.pathname;
const urls = String(data);

const getGroupName = (url) => {
  let f = url.split("/");
  let dats;

  for (let i = 2; i < f.length; i++) {
    if (f[i] === "driverportal") {
      dats = f[i + 1]
    }
  }
  return dats;
};

const oidcConfig = {
  authority: `${process.env.REACT_APP_PROXY_HOST}/auth/realms/${getGroupName(urls)}`,
  client_id: getGroupName(urls),
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

export default oidcConfig;
